import { useFiltersV2Select } from "PFApp/components/filters_v2";
import {
  areFiltersEqual,
  areFiltersPristine,
  areFilterValuesEmpty,
  hasAnyDefaultValue,
  hasAnyError
} from "PFCore/helpers/filters";
import { useMemo } from "react";

export const useFiltersBufferState = () => {
  const { mainFilters, buffer, childrenFilters, areChildrenOn } = useFiltersV2Select(
    "mainFilters",
    "buffer",
    "childrenFilters",
    "areChildrenOn"
  );

  const areMainFiltersModified = useMemo(
    () => !areFiltersEqual(buffer.mainFilters, mainFilters),
    [buffer.mainFilters, mainFilters]
  );

  const areChildrenFiltersModified = useMemo(
    () => !areFiltersEqual(buffer.childrenFilters, childrenFilters),
    [buffer.childrenFilters, childrenFilters]
  );

  const areMainFiltersDefaultOrEmpty = useMemo(
    () => areFiltersPristine(buffer.mainFilters),
    [buffer.mainFilters]
  );

  const areMainFiltersEmpty = useMemo(() => areFilterValuesEmpty(buffer.mainFilters), [buffer.mainFilters]);

  const areChildrenFiltersEmpty = useMemo(
    () => areFilterValuesEmpty(buffer.childrenFilters),
    [buffer.childrenFilters]
  );

  const areChildrenToggled = buffer.areChildrenOn !== areChildrenOn && !areChildrenFiltersEmpty;
  const isFiltersBufferDirty = areMainFiltersModified || areChildrenFiltersModified || areChildrenToggled;

  const hasAnyFilterDefinedDefaultValue = useMemo(
    () => hasAnyDefaultValue(buffer.mainFilters) || hasAnyDefaultValue(buffer.childrenFilters),
    [buffer.mainFilters, buffer.childrenFilters]
  );

  const hasErrors = useMemo(
    () => hasAnyError(buffer.mainFilters) || (areChildrenOn && hasAnyError(buffer.childrenFilters)),
    [areChildrenOn, buffer.childrenFilters, buffer.mainFilters]
  );

  return {
    hasErrors,
    isFiltersBufferDirty,
    areFiltersDefaultOrEmpty: areMainFiltersDefaultOrEmpty && !buffer.areChildrenOn,
    areFiltersEmpty: areMainFiltersEmpty && areChildrenFiltersEmpty,
    hasAnyFilterDefinedDefaultValue
  };
};
